import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { LoadingCard } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { Banknote } from 'lucide-react';

import { SortDirection, useGetLoanAchRequestsQuery } from '../../../../__generated__/graphql/api';
import { toUserAchRequestListItem, type UserAchRequestListItem } from './toUserAchRequestListItem';
import { useUserAchRequestsListConfig } from './useUserAchRequestsListConfig';

interface LoanAchRequestsTabProps {
  loanId: string;
}

export const LoanAchRequestsTab = ({ loanId }: LoanAchRequestsTabProps) => {
  const { data, loading, error } = useGetLoanAchRequestsQuery({
    variables: { loanId, insertedAtSortDirection: SortDirection.Desc },
    notifyOnNetworkStatusChange: true,
  });

  const { getColumns, initialTableState } = useUserAchRequestsListConfig();

  const rows: UserAchRequestListItem[] = (data?.loanAchRequests?.achRequests ?? [])
    .filter((r): r is NonNullable<typeof r> => Boolean(r))
    .map(toUserAchRequestListItem);

  if (loading && rows.length === 0) {
    return <LoadingCard />;
  }

  if (error) {
    return <EntityErrorBanner message="We couldn't load ACH requests." detail={error.message} />;
  }

  if (rows.length === 0) {
    return <EntityEmptyState icon={Banknote} title="This customer has no ACH requests on file." />;
  }

  return (
    <SmartTable
      title="ACH Requests"
      rows={rows}
      columns={getColumns()}
      loading={loading}
      initialState={initialTableState}
    />
  );
};
